/**
 * Dessin répété d'un cran à l'autre quand la question se note en icônes. Les valeurs sont celles du
 * discriminant renvoyé par l'API.
 *
 * L'étoile se compte — on en désigne trois sur cinq —, le smiley se lit : chaque visage dit un
 * degré de satisfaction, du plus mécontent au plus satisfait.
 */
export enum VISUAL_EMOJI {
    STAR = 'STAR',
    EMOJI = 'EMOJI',
}
